"use client";

import { NAVBAR_LOGO_HEIGHT } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { Role } from "@prisma/client";
import { Flex } from "@radix-ui/themes";
import { usePathname } from "next/navigation";
import Container from "./components/Container";
import { ExtendedSession } from "@/lib/interface/ExtendedSession";
import NavLogo from "./components/navbar/NavLogo";
import NavLinks from "./components/navbar/NavLinks";
import { navBarAdmin, navBarBase, navBarDefault } from "./components/navbar/styles";
import MobileNavSheet from "./components/navbar/MobileNavSheet";

const NavBar = ({ session }: { session: ExtendedSession | null }) => {
  const pathname = usePathname();

  // Don't show navbar on login page
  if (pathname === "/auth/signin") return null;

  if (session?.role === Role.ADMIN && pathname.startsWith("/admin")) return null;

  return (
    <nav
      className={cn(
        navBarBase,
        session?.role === Role.ADMIN ? navBarAdmin : navBarDefault
      )}
    >
      <Container className="w-full pb-0">
        <Flex justify="between" align="center" className="w-full">
          <Flex align="center" style={{ height: NAVBAR_LOGO_HEIGHT }} justify="start">
            <NavLogo isAdmin={session?.role === Role.ADMIN} height={40} />
          </Flex>

          {/* Desktop nav links */}
          <div className="hidden sm:block">
            <Flex align="center">
              <NavLinks session={session!} />
            </Flex>
          </div>

          {/* Mobile hamburger menu */}
          <div className="sm:hidden flex items-center">
            <MobileNavSheet session={session} />
          </div>
        </Flex>
      </Container>
    </nav>
  );
};

export default NavBar;
